import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "init-prop-view d-flex" }
const _hoisted_2 = {
  key: 0,
  class: "init-prop-form"
}
const _hoisted_3 = { class: "d-flex mx-10 my-1" }
const _hoisted_4 = {
  class: "text-lg-h6",
  style: {"width":"150px"}
}
const _hoisted_5 = { class: "tile-rank" }

import {ApiMap} from "@/api/type";
import {ref, watch} from "vue";
import {useApi} from "@/api/handler";
import {game, proposal} from "@/api";
import InitDelete from "@/components/proposal/init/InitDelete.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'InitProp',
  props: {
    data: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)
const teamPoints = ref<Array<{teamId: number, initialScore: number, gameId: number}> | null>(null)
const removedList = ref<Array<number>>([])

function initTeamPoints() {
  if (!GameStatus.value) return
  teamPoints.value = Array.from({ length: GameStatus.value.teamCount }, (_, i) => i + 1)
      .map(item => ({
        teamId: item,
        initialScore: 0,
        gameId: GameStatus.value!.id
      })).filter(item => !removedList.value.includes(item.teamId))
}

const useProposalInit = () => {
  if (!teamPoints.value) return
  useApi({
    api: proposal.ProposalInit(teamPoints.value),
    onSuccess: () => {emits('update')},
    tip: '提案赛初始化成功'
  })
}

const useRemovedList = () => {
  if (!GameStatus.value) return
  useApi({
    api: game.RemoveList(GameStatus.value.id),
    onSuccess: resp => {
      removedList.value = resp.data as Array<number>
      initTeamPoints()
    }
  })
}

watch(() => props.data, () => {
  GameStatus.value = props.data ?? null
  initTeamPoints()
  useRemovedList()
}, {immediate: true})

return (_ctx: any,_cache: any) => {
  const _component_v_number_input = _resolveComponent("v-number-input")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (teamPoints.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "ma-10 text-lg-h5 text-indigo-lighten-2" }, " 初始化积分阶段 ", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamPoints.value, (value, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, "第 " + _toDisplayString(value.teamId) + " 组", 1),
                _createVNode(_component_v_number_input, {
                  "max-width": "300",
                  density: "compact",
                  variant: "outlined",
                  min: 0,
                  modelValue: value.initialScore,
                  "onUpdate:modelValue": ($event: any) => ((value.initialScore) = $event),
                  "control-variant": "split"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]))
          }), 128)),
          _createVNode(_component_v_btn, {
            class: "ml-10 mt-5",
            color: "primary",
            "max-width": "450",
            width: "100%",
            onClick: useProposalInit
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("提交")
            ])),
            _: 1,
            __: [1]
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(InitDelete, {
        "show-delete": "",
        "max-height": "700",
        class: "ma-4",
        data: GameStatus.value,
        onUpdate: _cache[0] || (_cache[0] = ($event: any) => (emits('update')))
      }, null, 8, ["data"])
    ])
  ]))
}
}

})